import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';
import {combineLatest, BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistListItem} from '@modules/specialists/models/specialist-list-item';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {EventsService} from '@services/events.service';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-staff-list',
    templateUrl: 'staff-list.component.html'
})

export class StaffListComponent implements OnInit, OnDestroy {

    /**
     * Список отображаемых специалистов
     */
    public specialists: SpecialistListItem[] = [];

    public canEdit = false;

    /**
     * Id привязанных к объекту специалистов
     */
    private ids$ = new BehaviorSubject<number[]>([]);

    private destroyed$ = new Subject();

    private objectId: number;

    constructor(
        private specialistsProvider: SpecialistsProvider,
        private api: WorkingObjectsApiService,
        private events: EventsService,
        private route: ActivatedRoute,
        private authService: AuthService,
    ) {
    }

    ngOnInit() {
        this.objectId = +this.route.parent.snapshot.params.id;

        const staffIds = this.route.snapshot.data.data;

        if (staffIds && staffIds.length) {
            this.ids$.next(staffIds);
        }

        combineLatest(
            this.ids$,
            this.specialistsProvider.data$
        ).pipe(
            takeUntil(this.destroyed$),
        ).subscribe((value) => {
            const ids: number[] = value[0];
            const specialists: SpecialistViewInterface[] = value[1];
            this.specialists = specialists.filter(spec => ids.includes(spec.id)).map(spec => new SpecialistListItem(spec));
        }, () => {

        });

        this.canEdit = this.authService.hasPermissions([UserNamespace.Permission.workingObjectSpecialists]);
    }

    addSpecialist(id: number) {
        if (!id) {
            return;
        }

        const ids = [].concat(this.ids$.getValue());

        if (ids.includes(id)) {
            this.events.showNoty({
                type: 'warning',
                content: NotyMessagesEnum.workingObjectSpecialistDuplicateMessage
            });
            return;
        }

        ids.push(id);

        this.api.post({
            url: this.api.getSpecialistPath(this.objectId),
            dataBody: {
                specialistIds: ids
            }
        }).toPromise().then(() => {
            this.ids$.next(ids);
            this.events.showNoty({
                type: 'success',
                content: NotyMessagesEnum.workingObjectSpecialistUpdatedMessage,
            });
        }, () => {
            this.events.showNoty({
                type: 'error',
                content: NotyMessagesEnum.workingObjectSpecialistUpdatedFailMessage,
            });
        });
    }

    removeSpecialist(id: number) {
        this.api.deleteMultiple({
            url: this.api.getSpecialistPath(this.objectId),
            queryParams: {
                specialistIds: [id]
            }
        }).toPromise().then(() => {
            const ids = this.ids$.getValue();

            if (ids.includes(id)) {
                ids.splice(ids.indexOf(id), 1);
            }

            this.ids$.next(ids);
            this.events.showNoty({
                type: 'success',
                content: NotyMessagesEnum.workingObjectSpecialistRemovedMessage,
            });
        }, () => {
            this.events.showNoty({
                type: 'error',
                content: NotyMessagesEnum.workingObjectSpecialistRemovedFailMessage,
            });
        });
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }
}
